<template>
    <div class="row mt-3">
        <load v-if="loading" />
        <div v-else class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-0 shadow">
                        <div class="card-body">
                            <div class="tab-content">
                                <div class="animate__animated animate__fadeIn">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="d-flex mb-4">
                                                <div class="mr-auto">
                                                    <h5>
                                                        Famílias Beneficiárias:
                                                        #{{ programa.nome }}
                                                    </h5>
                                                </div>
                                                <div>
                                                    <b-button
                                                        :title="
                                                            $t(
                                                                'Exportar Beneficiários'
                                                            )
                                                        "
                                                        @click="exportar"
                                                        class="py-2 mb-3"
                                                        size="sm"
                                                        type="button"
                                                        v-b-tooltip.hover
                                                        variant="default"
                                                    >
                                                        <i
                                                            class="fas fa-file-download"
                                                        ></i>
                                                        {{
                                                            $t(
                                                                "Exportar Beneficiários"
                                                            )
                                                        }}
                                                    </b-button>
                                                </div>
                                                <div>
                                                    <div
                                                        class="input-group mb-3"
                                                    >
                                                        <b-input
                                                            :placeholder="
                                                                $t(
                                                                    'Type to search'
                                                                )
                                                            "
                                                            class="form-control search-input"
                                                            type="text"
                                                            v-model="search"
                                                            v-on:change="
                                                                getProgramas
                                                            "
                                                            aria-describedby="input-search"
                                                        />
                                                        <div
                                                            class="input-group-append"
                                                            role="button"
                                                        >
                                                            <span
                                                                class="input-group-text"
                                                                id="input-search"
                                                                ><i
                                                                    class="fas fa-search search-icon"
                                                            /></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <load
                                            mode="table"
                                            v-if="loadingProgramas"
                                        />
                                        <div class="col-12" v-else>
                                            <div
                                                v-if="isLoading"
                                                class="alert alert-info bg-gradient-info"
                                            >
                                                Por favor aguarde esse processo
                                                pode demorar alguns minutos...
                                            </div>
                                            <b-table
                                                :fields="[
                                                    {
                                                        key: 'protocolo',
                                                        label: $t('Detalhes'),
                                                    },
                                                    {
                                                        key: 'cadastrado',
                                                        label: $t('Data'),
                                                    },
                                                    {
                                                        key: 'status_nome',
                                                        label: $t('Status'),
                                                    },
                                                    {
                                                        key: 'actions',
                                                        label: '',
                                                        class: 'text-right',
                                                        thStyle: {
                                                            width: '95px',
                                                            minWidth: '95px',
                                                        },
                                                    },
                                                ]"
                                                :items="itensList"
                                                :responsive="true"
                                                striped
                                                hover
                                                show-empty
                                                small
                                                outlined
                                                stacked="md"
                                                table-class="mb-3"
                                            >
                                                <template
                                                    v-slot:cell(protocolo)="data"
                                                >
                                                    Beneficiário(s):<br />
                                                    <ul>
                                                        <li
                                                            v-for="pessoa in data
                                                                .item
                                                                .pessoas_objetos"
                                                            :key="pessoa.id"
                                                        >
                                                            <b
                                                                >{{
                                                                    pessoa.nome_completo
                                                                }}
                                                                <b-link
                                                                    :to="
                                                                        '/dashboard/programassociais/beneficiarios/' +
                                                                        pessoa.familia_id +
                                                                        '?familia_id=' +
                                                                        pessoa.familia_id
                                                                    "
                                                                >
                                                                    <i
                                                                        class="fas fa-external-link-alt"
                                                                    ></i> </b-link
                                                            ></b>
                                                        </li>
                                                    </ul>
                                                    Valor:
                                                    <b
                                                        >R$
                                                        {{ data.item.valor }}</b
                                                    >
                                                    <br />
                                                    <span
                                                        v-if="data.item.unidade"
                                                    >
                                                        Unidade:
                                                        <b
                                                            v-if="
                                                                data.item
                                                                    .unidade
                                                            "
                                                            >{{
                                                                data.item
                                                                    .unidade
                                                                    .nome
                                                            }}</b
                                                        >
                                                        <br />
                                                        Técnico
                                                        <b
                                                            v-if="
                                                                data.item.user
                                                            "
                                                            >{{
                                                                data.item.user
                                                                    .name
                                                            }}</b
                                                        >
                                                    </span>
                                                </template>
                                                <template
                                                    v-slot:cell(cadastrado)="data"
                                                >
                                                    {{ data.item.cadastrado }}
                                                </template>
                                                <template
                                                    v-slot:cell(status_nome)="data"
                                                >
                                                    <span
                                                        class="small"
                                                        v-html="
                                                            data.item
                                                                .status_nome
                                                        "
                                                    ></span>
                                                </template>
                                                <template v-slot:cell()="data">
                                                    <b-button
                                                        :to="
                                                            '/dashboard/programassociais/concessao/' +
                                                            data.item.id +
                                                            '/edit'
                                                        "
                                                        class="px-2 mb-0"
                                                        size="xs"
                                                        type="button"
                                                        v-b-tooltip.hover
                                                        variant="success"
                                                    >
                                                        <i
                                                            class="mdi mdi-square-edit-outline"
                                                        />
                                                    </b-button>
                                                </template>
                                                <template v-slot:empty="scope">
                                                    <div
                                                        class="text-center my-5"
                                                    >
                                                        <img
                                                            :alt="
                                                                $t('No results')
                                                            "
                                                            class="mb-5"
                                                            src="/img/icons/robot.svg"
                                                            style="
                                                                max-height: 165px;
                                                            "
                                                        />
                                                        <h3 class="bold">
                                                            {{
                                                                $t(
                                                                    "No records found"
                                                                )
                                                            }}
                                                        </h3>
                                                    </div>
                                                </template>
                                            </b-table>

                                            <div class="row align-items-center">
                                                <div class="col-lg-6 col-md-12">
                                                    <div
                                                        class="form-group d-inline-flex mb-0"
                                                    >
                                                        <select
                                                            class="form-control"
                                                            style="width: 70px"
                                                            v-model="perPage"
                                                            v-on:change="
                                                                getProgramas
                                                            "
                                                        >
                                                            <option value="5">
                                                                5
                                                            </option>
                                                            <option value="10">
                                                                10
                                                            </option>
                                                            <option value="25">
                                                                25
                                                            </option>
                                                            <option value="50">
                                                                50
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="d-inline-flex ml-2"
                                                    >
                                                        <b-pagination
                                                            :per-page="perPage"
                                                            :total-rows="
                                                                pagination.total
                                                            "
                                                            @change="changePage"
                                                            v-model="page"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-lg-6 col-md-12 mt-4 mt-lg-0"
                                                >
                                                    <div class="float-lg-right">
                                                        {{ $t("Showing page") }}
                                                        {{
                                                            pagination.currentPage
                                                        }}
                                                        {{ $t("of") }}
                                                        {{
                                                            pagination.totalPages
                                                        }}
                                                        {{ $t("pages in") }}
                                                        {{ pagination.total }}
                                                        {{ $t("records") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["programa"],
    name: "ReadBeneficiariosPrograma",
    data() {
        return {
            search: "",
            loading: true,
            loadingProgramas: true,
            familia: {},
            associar_programa: false,
            page: 1,
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            isLoading: false,
        };
    },
    mounted() {
        this.getProgramas();
    },
    methods: {
        getProgramas() {
            this.loadingProgramas = true;
            axios
                .get("api/dashboard/programasocial/beneficiarios", {
                    params: {
                        id: null,
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        programaId: this.programa.id,
                    },
                })
                .then((response) => {
                    this.user_id = this.$store.state.user.id;
                    this.itensList = response.data.data;
                    this.pagination = response.data.pagination;

                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getProgramas();
                    } else {
                        this.loading = false;
                        this.loadingProgramas = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.loadingProgramas = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getProgramas();
            }
        },
        exportar() {
            this.isLoading = true;
            swal.fire({
                title: "Aguarde",
                text: "O Arquivo está sendo gerado.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/programasocial/beneficiarios/exportar")
                .then((response) => {
                    swal.fire({
                        title: "Arquivo Pronto para Download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => (this.isLoading = false));
        },
    },
};
</script>

<style></style>
